import {
  fetchAreaToAreaStandardExport,
  fetchAreaToAreaStandardPage,
} from '@/services/cityToCityAreaToAreaStandard';

export default {
  namespace: 'areaToAreaStandardTable',
  state: {
    searchParams: {},
    list: [],
    total: 0,
    areaTypeOptions: [],
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      const result = yield call(fetchAreaToAreaStandardPage, payload);
      yield put({
        type: 'updateState',
        payload: {
          searchParams: payload || {},
          list: result?.data?.rows || [],
          total: result?.data?.total || 0,
        },
      });
      return result;
    },
    *exportData({ payload }, { call }) {
      return yield call(fetchAreaToAreaStandardExport, payload);
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
